// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';

export const updateListFilterBy = filterBy => ({
    payload: filterBy,
    property: 'filterBy',
    type: actions.UPDATE_CLAIMS_IN_PROGRESS_FILTER_BY
});

export const updateListSortBy = sortBy => ({
    payload: sortBy,
    property: 'sortBy',
    type: actions.UPDATE_CLAIMS_IN_PROGRESS_SORT_BY
});

export const updateListSortDirection = sortDirection => ({
    payload: sortDirection,
    property: 'sortDirection',
    type: actions.UPDATE_CLAIMS_IN_PROGRESS_SORT_DIRECTION
});



// WEBPACK FOOTER //
// ./src/claim/claims-in-progress/action-creators/search-filters.js